module.exports = __webpack_public_path__ + "img/apple-logo.060a28b3.svg";